<template>
  <div style="" class="hone-list">
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        :data="tableData"
        height="100%"
        @row-dblclick="_view"

        @row-click="_look"
      >
        <el-table-column prop="fType" label="类型" width="90" />
        <el-table-column prop="fTitle" label="主题" />
        <el-table-column prop="fDistributor" label="经销商" min-width="100" />
        <el-table-column prop="fCustomer" label="客户名称" min-width="100" />
        <el-table-column prop="fDate" label="时间" width="160px" />
        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="_view(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="row-info">{{ fContent }}</div> -->
    <div class="row-info">
      <el-input :value="fContent" type="textarea" :rows="6" />
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>

<script>
export default {
  // name: "Home",

  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,
      loading: false,
      tableData: [],
      fContent: '',
      timer: null,
      routerArr: [
        { keys: 'Order_create', path: '/orderManage/order' },
        { keys: 'Order_qy_s', path: '/orderManage/orderForQy' },
        { keys: 'Order_wl_s', path: '/orderManage/logisticsAudit' },
        { keys: 'Order_kj_s', path: '/orderManage/accountantAudit' },
        { keys: 'Order_cn_s', path: '/orderManage/cashierAudit' },
        { keys: 'Order_ck_q', path: '/orderManage/warehouseAffirm' },
        { keys: 'Order_wl_q', path: '/orderManage/logisticsAffirm' },
        { keys: 'Order_ccbc', path: '/orderManage/orderForCcbc' },

        { keys: 'DeliveryNote_ck', path: '/businessManagement/delivery' },
        {
          keys: 'DeliveryNote_jxs_q',
          path: '/businessManagement/deliveryForJxs'
        },
        {
          keys: 'DeliveryNote_cw_q',
          path: '/businessManagement/deliveryForCw'
        },

        { keys: 'Recharge_create', path: '/topUp/newPrepaidPhone' },
        { keys: 'Recharge_wl_s', path: '/topUp/logisticsAudit' },
        { keys: 'Recharge_cw_s', path: '/topUp/financialAudit' },

        { keys: 'ReturnGoods_create', path: '/saleRetrun/saleRetrunBill' },
        { keys: 'ReturnGoods_qy_s', path: '/saleRetrun/saleRetrunBillForQY' },
        { keys: 'ReturnGoods_wl_s', path: '/saleRetrun/saleRetrunBillForWL' },
        { keys: 'ReturnGoods_kj_s', path: '/saleRetrun/saleRetrunBillForKJ' },
        { keys: 'ReturnGoods_cn_s', path: '/saleRetrun/saleRetrunBillForCN' },
        { keys: 'ReturnGoods_ck_q', path: '/saleRetrun/saleRetrunBillForCK' },
        { keys: 'ReturnGoods_wl_q', path: '/saleRetrun/saleRetrunBillForWLQ' },
        { keys: 'ReturnGoods_cw_q', path: '/saleRetrun/saleRetrunBillForCWQ' },

        { keys: 'SalesRecord_create', path: '/distributorManagement/salesRecord' },
        { keys: 'SalesRecordSP1', path: '/distributorManagement/ReviewOfSalesRecords' }
      ]
    }
  },

  // activated() {
  //   this.refresh();
  //   console.log("1");
  // },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      // console.log(vm, 'enter')
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
        vm.settime()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    // vm.refresh()
  },
  beforeRouteLeave: function(to, from, next) {
    next()
    // const vm = this
    // console.log(to, 'to,leave')
    // console.log(next, 'next,leave')
    // console.log(vm, 'vm,leave')
    clearInterval(this.timer)
  },
  mounted() {
    // this.refresh()
  },
  methods: {
    refresh() {
      // console.log('123')
      this.loading = true
      this.$httpPost('HomePageMessageEntry', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    settime: function() {
      this.timer = setInterval(() => {
        this.refresh()
      }, 1000 * 60)
    },
    _look: function(row) {
      this.fContent = row.fContent
    },
    _view: async function(row) {
      // console.log(row, 'row')
      let paths = null
      const readonly = await this.$httpPost('OrderManage/GetBillState', {
        fid: row.fBillID,
        key: row.procedureKey
      }).then((res) => res.datalist)
      this.routerArr.forEach((val) => {
        // console.log(val, 'val')
        if (row.procedureKey == val.keys) {
          paths = val.path
        }
      })
      if (
        paths == '/topUp/newPrepaidPhone' ||
        paths == '/topUp/logisticsAudit' ||
        paths == '/topUp/financialAudit'
      ) {
        this.$router.push({
          path: paths,
          query: { fid: row.fBillID, ts: new Date().getTime() }
        })
        return
      }

      // console.log(paths, 'paths')
      if (paths !== null && paths !== undefined) {
        var url = paths + '/' + (readonly ? 'v/' : '') + row.fBillID
        this.$router.push({ path: url, query: { ishome: true }})
      }
    }
  }
}
</script>

<style lang="less">
.hone-list {
  height: 100%;
  flex: auto;
  display: flex;
  flex-direction: column;
  .row-info {
    overflow: auto;
    .el-textarea {
      .el-textarea__inner {
        color: rgb(0, 0, 0);
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
}
</style>
<style lang="less" scoped>
</style>
